import api from '../utils/api';

export const getOrders = async (params = {}) => {
  const response = await api.get('/orders', { params });
  return response.data;
};

export const getOrder = async (id) => {
  const response = await api.get(`/orders/${id}`);
  return response.data;
};

export const getOrdersStats = async (params = {}) => {
  const response = await api.get('/orders/stats', { params });
  return response.data;
};

export const createManualOrder = async (payload) => {
  const response = await api.post('/orders/manual', payload);
  return response.data;
};

